import fetcher from 'lib/fetcher';

import { MetaHead } from 'components/MetaHead/MetaHead';
import { HeaderWithOptions } from 'components/Header';
import { Footer } from 'components/Footer';
import BottomNavigationMap from 'components/BottomNavigation/BottomNavigationMap';
import { LegalDoc } from 'components/LegalDoc';

import type { Document } from '@contentful/rich-text-types';

interface PageProps {
  data?: { document: { 'de-DE': Document } };
}

export default function Page({ data }: PageProps): JSX.Element {
  const germanDocument = data?.document['de-DE'];

  const pdfLink =
    'https://legal-docs.smava.de/declarationOfConsentDataProtection.pdf';

  return (
    <>
      <MetaHead follow={false} index={false} />
      <HeaderWithOptions hasLoginLink hasNavigationMenu hasPhoneBox={false} />
      <LegalDoc document={germanDocument} pdfLink={pdfLink} />
      <BottomNavigationMap />
      <Footer />
    </>
  );
}

export async function getStaticProps() {
  const data = await fetcher(
    'https://legal-docs.smava.de/declarationOfConsentDataProtection.json',
  );

  return {
    props: { data },
    revalidate: 3600, // 1 hour
  };
}
